import type { CartItem } from '../../services/cartService';
import { clientCatalogPriceActivity, clientCatalogPriceStayPerNight } from '../../lib/quebecSalesTax';

/**
 * Per-unit price (tax-included) for cart line display — same as product cards.
 * Activities / packages: `clientCatalogPriceActivity` → TPS+TVQ on same pre-tax base (`quebecTaxFromPreTax`).
 * Stays: nightly total with same tax rules as `quebecSalesTax` (TH then TPS/TVQ on base+TH when applicable).
 * Returns `null` for VUM-included free lines.
 */
export function cartCatalogUnitPriceTaxIncl(item: CartItem): number | null {
  if (item.itemId.startsWith('vum-included-')) return null;
  if (item.type === 'accommodation') {
    return clientCatalogPriceStayPerNight(item.itemPrice, item.taxeHebergementEnabled !== false);
  }
  return clientCatalogPriceActivity(item.itemPrice);
}
